import {useParseBannersQuery} from '../../query/useParseBannersQuery';
import type {UseFormattedBannersParams} from './types';

export const useFormattedBanners = (params: UseFormattedBannersParams) => {
	const {data, isFetching, isPending} = useParseBannersQuery(params);

	const formattedBanners = data ?? [];
	const isProcessing = isFetching || isPending;
	const isEmpty = formattedBanners.length === 0;
	const isSingleItem = formattedBanners.length === 1;

	return {
		formattedBanners,
		isProcessing,
		isEmpty,
		isSingleItem,
	};
};
